export enum FilterTypes  {
    ID = 'ID',
    BOOL = 'BOOL',
    START_DATE = 'START_DATE',
    END_DATE = 'END_DATE',
    DATE = 'DATE'
}
